import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React, { useState } from 'react';
import classes from './NavBar.module.css';
import Logo from 'assets/images/logos/logo-dark-backgrounds.svg';
import MyRizaLeaf from 'assets/images/my-riza-leaf.svg';
import SearchIcon from 'assets/images/search.svg';
import FilterIcon from 'assets/images/sliders-h-square@3x.png';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import AccountUsersList from 'components/UI/NavBar/AccountUsersList/AccountUsersList';
import { getRgbFromColorName } from 'shared/utility';

const NavBar = (props) => {
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  const toggleSearchBar = () => {
    if (!showSearchBar) {
      setShowSearchBar(true);
    } else {
      setSearchInput('');
      setShowSearchBar(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleUserSnapMenuLaunch = () => {
    window.Usersnap.show(process.env.REACT_APP_USERSNAP_OPTIONS_MENU_KEY).then((widgetApi) => widgetApi.open());
    props.toggleAccountDropdown();
  };

  const navBarOuterContainerClasses = [classes.NavBarOuterContainer];
  if (!props.show) navBarOuterContainerClasses.push(classes.Hidden);
  const createAccountLinkClasses = props.currentPath.includes('/sign-up') ? [classes.NavLink, classes.Selected] : [classes.NavLink];
  const signInLinkClasses = props.currentPath.includes('/sign-in') ? [classes.NavLink, classes.Selected] : [classes.NavLink];
  const lifeSharedLinkClasses = props.currentPath.includes('life-shared') ? [classes.NavLink, classes.Selected] : [classes.NavLink];
  const myRizaLinkClasses = props.currentPath.includes('/my-riza') ? [classes.NavLink, classes.Selected] : [classes.NavLink];
  const growthLinkClasses = props.currentPath.includes('/growth') ? [classes.NavLink, classes.Selected] : [classes.NavLink];
  const nestLinkClasses = props.currentPath.includes('/nest') ? [classes.NavLink, classes.Selected] : [classes.NavLink];
  const lifeSharedLinkPath = props.currentPath.includes('life-shared/list') ? '/life-shared/list' : '/life-shared/timeline';
  const loveLinkClasses = props.currentPath.includes('/love') ? [classes.NavLink, classes.Selected] : [classes.NavLink];
  const searchContainerClasses = [classes.SearchBarContainer];
  const navBarInnerContainerClasses = [classes.NavBarInnerContainer];
  if (showSearchBar) {
    searchContainerClasses.push(classes.Shown);
  } else {
    navBarInnerContainerClasses.push(classes.Shown);
  }

  const postingAsUser = { ...props.postingAs };
  postingAsUser.isPostingUser = true;
  let accountUsersList = [];
  if (props.nonPostingUsers && props.nonPostingUsers.length > 0) {
    accountUsersList = props.nonPostingUsers.filter((user) => user.UserId !== postingAsUser.UserId);
  }
  accountUsersList.push(postingAsUser);

  const accountDropdown = (
    <Dropdown show={props.showAccountDropdown} className="Account">
      <div className={classes.DropdownContents}>
        <div className={classes.Profiles}>
          <h3>Profiles</h3>
          {props.postingAs && (
            <div>
              <AccountUsersList allUsers={accountUsersList} updatePostingAs={props.updatePostingAs} />
            </div>
          )}
        </div>
        <ul className={classes.Links}>
          <li onClick={() => props.handleNavLinkClick('/manage/my-account')}>Manage Account</li>
          <li onClick={() => props.handleNavLinkClick('/manage/logs')}>Manage Logs</li>
          <li onClick={handleUserSnapMenuLaunch}>Send Feedback</li>
          <li onClick={() => props.handleNavLinkClick('/help')}>Get Help</li>
          <li id="sign-out" onClick={() => props.handleNavLinkClick('/logout')}>
            Sign Out
          </li>
        </ul>
        <div
          style={{ height: '10px', width: '100%', marginBottom: '-10px' }}
          onDoubleClick={props.toggleServerListModal}
          className={classes.SwitchServersClickSpace}
        />
      </div>
    </Dropdown>
  );
  return (
    <div className={navBarOuterContainerClasses.join(' ')}>
      <div className={navBarInnerContainerClasses.join(' ')}>
        <img src={Logo} className={classes.RizaLogo} onClick={props.navLogoDisabled ? undefined : () => props.handleNavLinkClick('/')} alt="riza" />
        <div className={classes.NavBarOptions}>
          {props.isAuthenticated ? (
            props.profileCreated && !props.navLinksHidden ? (
              <ul className={classes.NavLinks}>
                <li id="my-riza" className={myRizaLinkClasses.join(' ')} onClick={() => props.handleNavLinkClick('/my-riza')}>
                  <img src={MyRizaLeaf} alt="my riza" />
                  <span>My Riza</span>
                </li>
                <li id="life-shared" className={lifeSharedLinkClasses.join(' ')} onClick={() => props.handleNavLinkClick(lifeSharedLinkPath)}>
                  <span>Life Shared</span>
                </li>
                <li className={growthLinkClasses.join(' ')} onClick={() => props.handleNavLinkClick('/growth')}>
                  <span>Growth</span>
                </li>
                <li className={nestLinkClasses.join(' ')} onClick={() => props.handleNavLinkClick('/nest')}>
                  <span>Nest</span>
                </li>
                <li id="love" className={loveLinkClasses.join(' ')} onClick={() => props.handleNavLinkClick('/love')}>
                  <span>Love</span>
                </li>
              </ul>
            ) : (
              <ul className={classes.NavLinks}>
                <li id="sign-out" className={signInLinkClasses.join(' ')} onClick={() => props.handleNavLinkClick('/logout')}>
                  <span>Sign Out</span>
                </li>
              </ul>
            )
          ) : (
            <ul className={[classes.NavLinks, classes.AuthFlow].join(' ')}>
              {['/verify', '/sign-up'].includes(props.currentPath) ? (
                <li className={classes.AlreadyHaveAccount}>Already have an account?</li>
              ) : (
                <li id="sign-up" className={createAccountLinkClasses.join(' ')} onClick={() => props.handleNavLinkClick('/sign-up')}>
                  <span>Create Account</span>
                </li>
              )}

              <li id="sign-in" className={signInLinkClasses.join(' ')} onClick={() => props.handleNavLinkClick('/sign-in')}>
                <span>Sign In</span>
              </li>
            </ul>
          )}
          {props.isAuthenticated && !props.navLinksHidden && (
            <div className={classes.SearchAccountIcons}>
              {/* {!showSearchBar ? <img src={SearchIcon} alt="search" onClick={toggleSearchBar} className={classes.SearchIcon} /> : null} */}
              <div id="accountDropdownContainer" className={classes.AccountContainer}>
                {_get(props, 'postingAs.ImageURL', _get(props, 'postingAs.ThumbURL')) ? (
                  <img
                    id="account-link"
                    src={_get(props, 'postingAs.ImageURL', _get(props, 'postingAs.ThumbURL'))}
                    alt={props.postingAs.FirstName}
                    className={classes.PostAsThumbImage}
                    style={{
                      border: props.postingAs.Color ? `2px solid ${getRgbFromColorName(props.postingAs.Color)}` : '2px solid rgb(108, 162, 183)',
                    }}
                    onClick={props.toggleAccountDropdown}
                  />
                ) : (
                  <FontAwesomeIcon
                    id="account-link"
                    icon="user-circle"
                    style={{ color: props.postingAs.Color ? getRgbFromColorName(props.postingAs.Color) : 'rgb(108, 162, 183)' }}
                    className={classes.UserIcon}
                    onClick={props.toggleAccountDropdown}
                  />
                )}
                {accountDropdown}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={searchContainerClasses.join(' ')}>
        <div className={classes.SearchBar}>
          <img src={SearchIcon} alt="search" className={classes.SearchIcon} />
          <input
            type="text"
            ref={(input) => input && input.focus()}
            placeholder="Your Search Input"
            className={classes.SearchInput}
            value={searchInput}
            onChange={(e) => handleSearchChange(e)}
          />
          <div className={classes.OpenFilters}>
            <img src={FilterIcon} alt="filter" className={classes.FilterIcon} />
            <p>Open Filters</p>
          </div>
          <FontAwesomeIcon className={classes.CloseSearch} onClick={toggleSearchBar} icon="times" />
        </div>
        <div className={classes.SearchResults}>
          <div className={classes.SearchResultsInner} />
        </div>
      </div>
    </div>
  );
};

export default NavBar;
